<template>
    <div v-if="list.length !== 0" class="mt-3 d-flex justify-content-start cursor-default">

        <Paginate :page-count="totalPages" :click-handler="onPageChange" prev-text="Prev" next-text="Next"
            :container-class="'pagination'" first-last-button />
    </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import Paginate from "vuejs-paginate-next";

const props = defineProps({
    list: Array,
    currentPage: Number,
    totalPages: Number,
    handlePreviousPage: Function,
    handleNextPage: Function,
});

const emit = defineEmits(["update:page"]);

const onPageChange = (page) => {
    if (page < props.currentPage) props.handlePreviousPage();
    else if (page > props.currentPage) props.handleNextPage();

    emit("update:page", page);
};
</script>

<style scoped>
.page-link {
    cursor: pointer;
    font-weight: 600;
}
</style>
